import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ProductQuantity from 'components/ProductQuantity';
import { features } from 'config'
import PubSub from 'services/PubSub/';
import style from './style.scss';//NOSONAR

let config = {
    buyTitle: "Agregar",
    maxItems: 9999,
    listButton: false
};

const ProductListItem = (props) => {
    const [quantity, setQuantity] = useState(0);
    const [stateCheck, setStateCheck] = useState(false);

    if (props.config) {
        Object.assign(config, props.config)
    }

    let item = {
        id: props.item.id,
        name: props.item.name,
        quantity: 0,
        scheduleStatus : props.item.scheduleStatus
    };

    useEffect(() => {
        const stateChecked = !(props.item.quantity && props.item.quantity <= 0);
        
        if (props.item.quantity) {
            setQuantity(props.item.quantity);
            setStateCheck(stateChecked);
        }

        config.maxItems = config.maxItems / config.unitMultiplier
    }, []);

    const increaseQuantity = () => {
        let qty = quantity;
        qty++;
        if (qty > config.maxItems) qty = config.maxItems;
        setQuantity(qty);
        setStateCheck(true);

        PubSub.dispatch('modal_quantity_value', {
            quantity: qty,
            id: item.id,
            stateCheck: true,
            name: props.item.name
        });
    }

    const decreaseQuantity = () => {
        let qty = quantity;
        qty--;
        let stateChecked = false;
        if (qty <= 0) {
            qty = 0;

            PubSub.dispatch('modal_quantity_value', {
                quantity: qty,
                id: item.id,
                stateCheck: false,
                name: props.item.name
            });

        } else {

            PubSub.dispatch('modal_quantity_value', {
                quantity: qty,
                id: item.id,
                stateCheck: true,
                name: props.item.name
            });

            stateChecked = true;
        }

        setQuantity(qty);
        setStateCheck(stateChecked);
    }

    const selectItem = (event) => {
        let qty = quantity;
        if (qty == 0) {
            qty = 1;
        }
        if (!event.target.checked) {
            qty = 0;
        }

        setStateCheck(event.target.checked != false);
        setQuantity(qty);

        PubSub.dispatch('modal_quantity_value', {
            quantity: qty,
            id: item.id,
            stateCheck: event.target.checked != false,
            name: props.item.name
        });
    }

    const setQty = props?.item && props?.item?.skus && (Object.keys(props?.item?.skus).length > 0) ? Object.keys(props?.item?.skus).length + ' productos' : 'Sin productos';
    const statusSchedule = item.scheduleStatus;

    return (
        <div className="add-to-list-item-container">
            {((statusSchedule === null) && features.rescheduleListFlag) && <div className="status-reschedule-wrapper">
                <span className="pill-status-reschedule">Pedido programado</span>
            </div>}
            {((statusSchedule === 2) && features.rescheduleListFlag) && <div className="status-reschedule-wrapper">
                <span className="pill-status-suspended">Suspendido</span>
            </div>}
            <div className="modal-add-to-list-item">
                <label className="modal-add-to-list-container-actions">
                    <input type="checkbox" className="modal-add-to-list-checkbox" checked={stateCheck} onChange={(event) => selectItem(event)} />
                    <div className="modal-add-to-list-wrapper">
                        <span className={"modal-add-to-list-span " + (features.showQtyAddToList ? ' show-qty ' : '')}>
                            {item.name}
                        </span>
                        {features.showQtyAddToList && <span className="add-list-product-qty">{setQty}</span>}
                    </div>
                </label>
                <div className="modal-add-to-list-quantity-controls">
                    {(props.config && props.config.unitMultiplier) && <div className="modal-add-to-list-quantity-container">
                        {(quantity) ? <span className="modal-add-to-list-quantity-input"><ProductQuantity quantity={quantity} item={config}/></span> : <button className="secundary-btn add-list-btn" onClick={increaseQuantity}>Agregar</button>}
                        {(quantity !== 0) && <div className="modal-add-to-list-container-buttons">
                            <button onClick={decreaseQuantity} className={'secundary-btn modal-add-to-list-quantity-btn minus' + (quantity <= 1 ? ' disabled-btn ' : '')}></button>
                            <button onClick={increaseQuantity} className={'primary-btn modal-add-to-list-quantity-btn plus' + (quantity >= config.maxItems ? ' disabled-btn ' : '')}></button>
                        </div>}
                    </div>}
                </div>
            </div>
            {((statusSchedule === null) && features.rescheduleListFlag) && <div className="message-not-reschedule">
                <span>Este producto no se puede programar</span>
            </div>}
        </div>
    )
}

ProductListItem.propTypes = {
    config: PropTypes.object,
    item: PropTypes.object
}
export default ProductListItem;
